require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-ruby-ruby-on-rails.json") })
        }
      }, "path---projects-ruby-ruby-on-rails");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-ruby-ruby-on-rails!./.cache/json/projects-ruby-ruby-on-rails.json
// module id = 357
// module chunks = 231608221292675